import { ITaskDenormalized } from '@dadohr/shared/domainTypes/experience';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const TaskCompletionCriteria = ({
  criteria,
  totalSubTaskCount
}: {
  criteria: ITaskDenormalized['customCompletionCriteria'];
  totalSubTaskCount: number;
}) => {
  const { t } = useTranslation();
  if (!criteria.length) {
    return null;
  }
  if (criteria.length > 1) {
    console.log(
      'Several completion criteria found, but only supporting one at the moment',
      criteria
    );
  }
  const criterium = criteria[0];
  if (criterium.type !== 'SUBSET') {
    console.log('Criterium not supported yet', criterium);
    return null;
  }

  return (
    <Typography variant="caption">
      {t('taskCompletionCriteria.adminFacing.hint', {
        requiredCount: criterium.minimumRequired,
        count: totalSubTaskCount
      })}
    </Typography>
  );
};
